module.exports = __webpack_public_path__ + "static/qoo10-c2b6af8ba8766e45258836092c9bb586.png";